import { FC } from 'react';
import { Button, Spinner } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  onClick: (type: string) => void;
  isLoading?: boolean
}

const ButtonExport: FC<IProps> = ({
  onClick, isLoading
}) => {
  return (
    <Button
      onClick={() => onClick("Excel")}
      type="button"
    >
      {isLoading &&
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      }
      <FontAwesomeIcon icon={faFileExcel} className='me-2' />
      <span>{t("EXPORT")}</span>
    </Button>
  );
}

export default ButtonExport;